import { useEffect } from "react";
import { validatePaste, regexRestriction } from "../utils/validators";
import { ThemeTypes } from "@zf/react-frontend-vite";
import { Autocomplete, TextField } from "@mui/material";
import ReactDOM from "react-dom";

const useFromChange = (
  bubbles,
  changeForm,
  setChangeForm,
  botProps,
  selectedAsset,
  options,
  onOptionClick,
) => {
  useEffect(() => {
    if (!changeForm) return;
    const card = bubbles[bubbles.length - 1]?.querySelector(".ac-adaptiveCard");
    if (!card) return;

    // ---- ELEMENTS ----
    const inputEl = card.querySelector("#asset input");
    if (!inputEl) return;
    if (inputEl?.dataset?.replaced) return;

    const textarea = card.querySelector("#remarks textarea");
    const deskNum = card.querySelector("#desknumber input");

    if (!inputEl || !textarea || !deskNum) return;

    if (!options.length) return;

    inputEl.style.position = "absolute";
    inputEl.style.opacity = "0";
    inputEl.style.width = "0";
    inputEl.style.height = "0";
    inputEl.style.pointerEvents = "none";

    const container = document.createElement("div");
    container.classList.add("mui-autocomplete-container");
    inputEl.parentNode?.insertBefore(container, inputEl.nextSibling);

    const handleInputChange = (_event, newInputValue) => {
      inputEl.value = newInputValue;

      inputEl.dispatchEvent(new Event("input", { bubbles: true }));
      inputEl.dispatchEvent(new Event("change", { bubbles: true }));

      const muiInput = container.querySelector("input");
      if (muiInput) {
        muiInput.dataset.hasValue = !!newInputValue;
        muiInput.dispatchEvent(
          new CustomEvent("autocompleteChange", {
            bubbles: true,
            composed: true,
          }),
        );
      }
    };

    const handleChange = (_event, value, reason) => {
      const selectedValue = Array.isArray(value) ? value[0] : value || "";

      if (reason === "selectOption" && onOptionClick) {
        onOptionClick(selectedValue);
      }
    };

    ReactDOM.render(
      <Autocomplete
        options={options}
        freeSolo
        defaultValue={inputEl.value || ""}
        onChange={handleChange}
        onInputChange={handleInputChange}
        renderInput={(params) => (
          <TextField {...params} sx={{ width: "100%" }} />
        )}
      />,
      container,
    );

    inputEl.dataset.replaced = "true";
    setChangeForm(false);

    // ---- THEME FIX ----
    if (botProps.screenReducer.theme === ThemeTypes.DARK) {
      const warningText = card.querySelectorAll(".ac-textBlock")[1];
      if (warningText) warningText.style.color = "rgb(255 128 0)";
    }

    // ---- INPUT RULES ----
    deskNum.maxLength = 50;
    deskNum.addEventListener("keypress", regexRestriction);
    deskNum.addEventListener("paste", validatePaste);

    textarea.maxLength = 500;
    textarea.addEventListener("paste", validatePaste);
    textarea.addEventListener("keypress", regexRestriction);

    // ---- CLEANUP ----
    return () => {
      deskNum.removeEventListener("keypress", regexRestriction);
      deskNum.removeEventListener("paste", validatePaste);

      textarea.removeEventListener("paste", validatePaste);
      textarea.removeEventListener("keypress", regexRestriction);
    };
  }, [bubbles.length, changeForm, selectedAsset]);
};
export default useFromChange;
